import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@services/user.service';
import { WebErrorService } from '@services/webError.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'purchase-history',
  templateUrl: './purchase-history.component.html',
  styleUrls: ['./purchase-history.component.scss']
})
export class PurchaseHistoryComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) set content(paginator: MatPaginator) { }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  purchase: any;
  endDate: any;
  startDate: any;
  public noDataFound: boolean = false;
  public lastDays: string = "30";

  displayed: string[] = ['Transaction Id', 'Credits Purchased', 'Purchased data'];

  private unsubscribe: Subject<void> = new Subject<void>();
  showPaginator = false;

  constructor(private userService: UserService, public datepipe: DatePipe, private webErrorService: WebErrorService, private translate: TranslateService) { }

  ngOnInit(): void {
    this.last30Days();
  }

  last30Days() {
    this.lastDays = "30";
    this.endDate = new Date();
    this.startDate = new Date(new Date().setDate(this.endDate.getDate() - 30));
    this.getPurchaseHistory();

  }

  last90Days() {
    this.lastDays = "90";
    this.endDate = new Date();
    this.startDate = new Date(new Date().setDate(this.endDate.getDate() - 90));
    this.getPurchaseHistory();

  }

  getPurchaseHistory(data?: string) {
    if (!!data && data === "search") { this.lastDays = "" }

    const StartDate = this.datepipe.transform(this.startDate, 'dd-MM-yyyy');
    const EndDate = this.datepipe.transform(this.endDate, 'dd-MM-yyyy');
    const newLocal: Subscription = this.userService.getpurchasehistory(StartDate, EndDate).subscribe(ress => {
      this.purchase = new MatTableDataSource(ress.purchaseHistories);
      this.purchase.sort = this.sort;
      this.purchase.paginator = this.paginator;
      this.setPaginatorTranslation(this.purchase);
      if (ress.purchaseHistories.length == 0) {
        this.noDataFound = true;
      } else {
        this.noDataFound = false;
      }
    }, (error: any) => { this.webErrorService.handleAPIErrors(error); }, () => { newLocal.unsubscribe() });
  }


  setPaginatorTranslation(data: any) {
    if (data.data.length > 0) {
      this.showPaginator = true;
      this.translate.stream([
        'subscription.TabPurchaseHist.pagination.pageLabel',
        'subscription.TabPurchaseHist.pagination.firstPage',
        'subscription.TabPurchaseHist.pagination.lastPage',
        'subscription.TabPurchaseHist.pagination.nextPage',
        'subscription.TabPurchaseHist.pagination.prevPage'
      ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
        data.paginator._intl.itemsPerPageLabel = translation['subscription.TabPurchaseHist.pagination.pageLabel'];
        data.paginator._intl.firstPageLabel = translation['subscription.TabPurchaseHist.pagination.firstPage'];
        data.paginator._intl.lastPageLabel = translation['subscription.TabPurchaseHist.pagination.lastPage'];
        data.paginator._intl.nextPageLabel = translation['subscription.TabPurchaseHist.pagination.nextPage'];
        data.paginator._intl.previousPageLabel = translation['subscription.TabPurchaseHist.pagination.prevPage'];

        data.paginator._intl.changes.next();
      });
    } else {
      this.showPaginator = false;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
